import { downloadSection } from '@/mocks/home';

export default function DownloadSection() {
  return (
    <section id="download" className="w-full py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
              {downloadSection.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-500 mb-8">
              {downloadSection.subtitle}
            </p>

            <div className="flex flex-wrap justify-center lg:justify-start gap-3 mb-8">
              {downloadSection.features.map((feat) => (
                <span
                  key={feat}
                  className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium"
                >
                  <i className="ri-check-line text-accent-600"></i>
                  {feat}
                </span>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row justify-center lg:justify-start gap-4">
              <button className="flex items-center justify-center gap-2 px-8 py-3.5 bg-foreground-950 text-background-50 rounded-full text-sm font-semibold hover:bg-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store 下载
              </button>
              <button className="flex items-center justify-center gap-2 px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </button>
            </div>

            <p className="mt-6 text-xs text-foreground-400">
              支持 iOS 14.0+ ｜ Android 8.0+ ｜ 版本 V8.0.1
            </p>
          </div>

          <div className="flex-1 flex justify-center">
            <div className="relative">
              <div className="w-64 h-[420px] rounded-3xl bg-gradient-to-br from-primary-500/20 via-accent-500/20 to-primary-500/10 overflow-hidden border-4 border-background-200 shadow-sm">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20screen%20displaying%20a%20video%20app%20interface%20with%20colorful%20video%20thumbnails%20in%20a%20clean%20minimal%20design%2C%20mobile%20app%20mockup%2C%20warm%20tones%2C%20professional%20UI%20design&width=600&height=1000&seq=app-mockup-01&orientation=portrait"
                  alt="快猫 App 界面展示"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-4 -right-4 w-16 h-16 rounded-full bg-primary-500 flex items-center justify-center shadow-sm">
                <i className="ri-play-fill text-background-50 text-2xl"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}